var exports = {
  "h": "DesktopNotificationNagbar.module__description___S3VYTU",
};

module.exports = exports;
